import Index from '@/pages/index';

export default function Custom404() {
	return <Index />;
}
